import I18n from 'I18n';
import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
import getLangLocale from 'I18n/utils/getLangLocale';
import { createAuthRegistry } from './registry';
import { initializeDefaults } from './defaults';
function makeI18nLoader() {
  // Provider is created once per call. setLocale is called on the first
  // register() invocation so it runs at render-time (after app I18n bootstrap
  // in production). localeReady tracks whether setLocale has been called for
  // THIS provider instance — it resets on HMR and on clearRegistry() so we
  // never end up with an unresolved localePromise after module re-evaluation.
  let provider = createStandardI18nProvider();
  let localeReady = false;
  return {
    register: lang => {
      if (!localeReady) {
        const i18n = I18n;
        try {
          var _i18n$langEnabled;
          provider.setLocale({
            locale: getLangLocale() || 'en-us',
            langEnabled: (_i18n$langEnabled = i18n.langEnabled) !== null && _i18n$langEnabled !== void 0 ? _i18n$langEnabled : true
          });
          localeReady = true;
        } catch (_unused) {
          // setLocale failed; leave localeReady=false so next call retries
        }
      }
      return provider.register(lang);
    },
    reset: () => {
      provider = createStandardI18nProvider();
      localeReady = false;
    }
  };
}
const i18nLoader = makeI18nLoader();
export const defaultRegistry = createAuthRegistry({
  initializer: initializeDefaults,
  i18nLoader,
  onClear: () => i18nLoader.reset()
});